module.exports = __webpack_public_path__ + "2e5ca59e82834612309d971fc60b5c4b.jpg";